const DistributionPriceFragment = `
    id
    currency
    price
`

export default DistributionPriceFragment
